import script from "./ExamListCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamListCategory.vue?vue&type=script&setup=true&lang=ts"

import "./ExamListCategory.vue?vue&type=style&index=0&id=66b9ee10&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66b9ee10"]])

export default __exports__